/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./midi-creator.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./midi-creator.component";
var styles_MidiCreatorComponent = [i0.styles];
var RenderType_MidiCreatorComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_MidiCreatorComponent, data: {} });
export { RenderType_MidiCreatorComponent as RenderType_MidiCreatorComponent };
export function View_MidiCreatorComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "p", [], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, ["midi-creator works!"]))], null, null); }
export function View_MidiCreatorComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "mat-midi-creator", [], null, null, null, View_MidiCreatorComponent_0, RenderType_MidiCreatorComponent)), i1.ɵdid(1, 114688, null, 0, i2.MidiCreatorComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var MidiCreatorComponentNgFactory = i1.ɵccf("mat-midi-creator", i2.MidiCreatorComponent, View_MidiCreatorComponent_Host_0, {}, {}, []);
export { MidiCreatorComponentNgFactory as MidiCreatorComponentNgFactory };
